/**
 * Decodes HTML entities in plain text from APIs (e.g. &#x27; → ').
 * Repeats until stable to handle double-encoded strings like &amp;#x27;.
 */
export function decodeHtmlEntities(text: string | null | undefined): string {
  if (text == null || text === '') return '';

  if (typeof document !== 'undefined') {
    let out = text;
    let prev = '';
    let guard = 0;
    while (out !== prev && guard < 8) {
      prev = out;
      const el = document.createElement('textarea');
      el.innerHTML = out;
      out = el.value;
      guard += 1;
    }
    return out;
  }

  let out = text;
  let prev = '';
  let guard = 0;
  while (out !== prev && guard < 8) {
    prev = out;
    out = out
      .replace(/&#x([0-9a-f]+);/gi, (_, h) => String.fromCharCode(parseInt(h, 16)))
      .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(parseInt(n, 10)))
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&#39;/g, "'");
    guard += 1;
  }
  return out;
}
